import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./assets/style/style.scss"
import { LanguageProvider } from './context/LangaugeContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LanguageProvider>
    <App />
    </LanguageProvider>
);


